import { useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processAuth = async () => {
            const hash = window.location.hash;
            const sessionIdMatch = hash.match(/session_id=([^&]+)/);
            
            if (!sessionIdMatch) {
                window.location.href = '/';
                return;
            }

            const sessionId = sessionIdMatch[1];

            try {
                const response = await fetch(`${API}/auth/session`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ session_id: sessionId })
                });

                if (response.ok) {
                    window.location.replace('/dashboard');
                } else {
                    window.location.href = '/';
                }
            } catch (error) {
                window.location.href = '/';
            }
        };

        processAuth();
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="text-center">
                <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-muted-foreground font-display tracking-wider">Signing you in...</p>
            </div>
        </div>
    );
}
